export interface RenameFileParams {
  id: number;
  parentId: number;
  name: string;
  isFolder?: boolean;
  entityInstanceId?: number;
}

export interface GetFolderParams {
  id: number;
  name: string;
  parentId: number;
}

export interface CreateFolderParams {
  parentId: number;
  name: string;
  setOnContract?: boolean;
  entityInstanceId?: number;
}

export interface EditFolderParams {
  id: number;
  name: string;
  parentId: number;
  entityInstanceId?: number;
}

export interface GetUploadUrlParams {
  parentId: number;
  mimeType: string;
  isCreateVersion?: boolean;
  entityInstanceId?: number;
}

export interface GetVersionUrlParams {
  fileId: number;
  mimeType: string;
  entityInstanceId?: number;
}

export interface SaveFileInfoParams {
  mimeType: string;
  isCreateVersion?: boolean;
  fileId: string;
  totalBlocks: number;
  parentId: number;
  roleId?: number;
  entityInstanceId?: number;
}

export interface AddChunkedVersionParams {
  fileId: number;
  physicalId: string;
  totalBlocks: number;
  mimeType: string;
  roleId?: number;
  entityInstanceId?: number;
}

export interface DuplicateVersionParams {
  roleId?: number;
  entityInstanceId?: number;
}

export interface DuplicateVersionBody {
  fileId: number;
  versionId: number;
}

export interface SaveFileInfoBody {
  fileName: string;
  bytes: number;
}

export interface DeleteSharesParams {
  fileId: number;
  usersId: number[];
}

export interface ShareFilesModel {
  filesId: number[];
  usersId: number[];
  sendNotification?: boolean;
  sendFile?: boolean;
  comment?: string;
}

export interface GlobalFilesModel {
  filesId: number[];
}

export interface DeleteFileRef {
  id: number;
  folderId: number;
}

export interface DeleteItemsModel {
  files: DeleteFileRef[];
  foldersId: number[];
}

export interface RestoreItemsModel extends DeleteItemsModel {
  restoreToNew: boolean;
}

export interface ZipItemsModel {
  filesId: number[];
  foldersId: number[];
  rootModuleId?: number;
}

export interface MoveItemsModel {
  filesId: number[];
  foldersId: number[];
  destinationFolderId: number;
  isDestinationEntityInstance: boolean;
  entityInstanceId?: number;
  destinationEntityInstanceId?: number;
  rootModuleId?: number;
}

export interface GetFolderParentsParams {
  folderId: number;
  entityInstanceId?: number;
  folderEntityInstanceId?: number;
  archiveId?: number;
}

export interface FolderParentModel {
  id: number;
  name: string;
  isEntityInstance: boolean;
  archiveId?: number;
  parentId?: number;
  entityInstanceId?: number;
}
